import { 
    apiBizEContractDepositAndBillSetting,
    apiBizEContractNotify,
    apiBizGetContractPeriod
} from "@/apis/api.js"; 
import { 
    getRenewalContract,
    setRenewal
} from "@/apis/company/renewalContract.js"; 

const defaultContractData = {
    "tenantName" : null,
    "tenantPhone" : null,
    "tenantIdNumber" : null,
    "contractBeginTime" : null,
    "rentalPeriod" : null,
    "tenantNumber" : null,
    "contractVersionId" : null,
}
const defaultIdentification = {
    font: [],
    back: []
}
const defaultDatePeriod = {
    contractPeriod: [],
    billPeriod: []
}
const defaultSelectedHouseInfo = {
    seleted: null,
    houseCid: null,
    houseName: null,
    rent: 0,
    address: null,
    houseStatus: null,
    moveInDate: null,
    contractPeriod: [],
    agentName: null
}
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_contract_id: 'bizRenewalContract/set_contract_id',
    set_nonbooking_contract: 'bizRenewalContract/set_nonbooking_contract',
    set_contract_status: 'bizRenewalContract/set_contract_status',
    set_notify_status: 'bizRenewalContract/set_notify_status',
    set_signed_status: 'bizRenewalContract/set_signed_status',
    set_contract_data: 'bizRenewalContract/set_contract_data',
    set_date_period: 'bizRenewalContract/set_date_period',
    set_default: 'bizRenewalContract/set_default',
    set_contract_period: 'bizRenewalContract/set_contract_period',
    set_renewal_contract: 'bizRenewalContract/set_renewal_contract',
    set_selected_house: 'bizRenewalContract/set_selected_house',
}

// count state 必須是 Object
const state = {
    contractId: null,
    contractStatus: 1,
    isSinged: false,
    nonbookingContract: {
        nonBookingContractCid: null,
        contractDeposit: 0,
        contractBeginTime: null
    },
    contractData: Object.assign({}, defaultContractData),
    identification: Object.assign({}, defaultIdentification),
    datePeriod: Object.assign({}, defaultDatePeriod),
    selectedHouseInfo: Object.assign({}, defaultSelectedHouseInfo),
    availableHouseList: [],
    contractPeriod: [],
    renewalContract: {}
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_RENEWAL_CONTRACT_ID: (state) => {
        return state.contractId
    },
    GET_BIZ_RENEWAL_NONBOOKING_CONTRACT: (state) => {
        return state.nonbookingContract
    },
    GET_BIZ_RENEWAL_CONTRACT_STATUS: (state) => {
        return state.contractStatus
    },
    GET_BIZ_RENEWAL_SIGNED_STATUS: (state) => {
        return state.isSinged
    },
    GET_BIZ_RENEWAL_CONTRACT_DATA: (state) => {
        return state.contractData
    },
    GET_BIZ_RENEWAL_CONTRACT_IDENTIFICATION: (state) => {
        return state.identification
    },
    GET_BIZ_RENEWAL_CONTRACT_DATE_PERIOD: (state) => {
        return state.datePeriod
    },
    GET_BIZ_RENEWAL_CONTRACT_SELECTED_HOUSE: (state) => {
        return state.selectedHouseInfo
    },
    GET_BIZ_RENEWAL_CONTRACT_AVAILABLE_HOUSE: (state) => {
        return state.availableHouseList
    },
    GET_BIZ_RENEWAL_CONTRACT_PERIOD: (state) => {
        return state.datePeriod
    },
    GET_BIZ_RENEWAL_CONTRACT_OBJ: (state) => {
        return state.renewalContract
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizRenewalContract ( {commit}, params ) {
        return new Promise((resolve, reject) => {
            getRenewalContract(params)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_renewal_contract, res.data.result)
                }
                resolve()
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    getBizGetRenewalContractPeriod ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetContractPeriod(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_contract_period, res.data.result);
                    resolve(true)
                }else{
                    resolve(false)
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setBizRenewalContractId ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_id, data);
            resolve()
        })
    },
    saveBizRenewalContract ( {commit, dispatch, state} , data) {
        return new Promise((resolve, reject) => {
            setRenewal(data)
            .then(res => {
                console.log('儲存合約基本資料')
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_nonbooking_contract, res.data.result)
                    resolve(true)
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    resolve(false)
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveBizRenewalContractBill ( {commit, dispatch, state} , data) {
        return new Promise((resolve, reject) => {
            apiBizEContractDepositAndBillSetting(data)
            .then(res => {
                console.log('儲存合約基本資料')
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_contract_id, res.data.result.contractCid)
                    resolve(true)
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    resolve(false)
                }
                resolve()
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    bizRenewalNotifyTanant ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            
            apiBizEContractNotify(data)
            .then(res => {
                console.log('打通知租客ＡＰＩ')
                if( res.data.status == "SUCCESS" ){
                    resolve(true)
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    resolve(false)
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    bizSetRenewalContractStatus ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_status, data)
        })
    },
    bizSetRenewalContractSingedStatus ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_signed_status, data)
        })
    },
    bizSetRenewalContractData ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_data, data)
        })
    },
    bizSetRenewalContractIOdentification ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_id_card_img, data)
        })
    },
    bizSetRenewalContractDatePeriod ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_date_period, data)
        })
    },
    bizSetRenewalContractSelectedHouse ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_selected_house, data)
        })
    },
    bizSetRenewalContractDefault ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_default)
        })
    }
}

// mutations
const mutations = {
    [types.set_contract_id](state, data){
        state.contractId = data
    },
    [types.set_nonbooking_contract](state, data){
        state.nonbookingContract = data
    },
    [types.set_contract_period](state, data){
        state.contractPeriod = data
    },
    [types.set_contract_status](state, data){
        state.contractStatus = data
    },
    [types.set_notify_status](state, data){
        state.notifyStatus = data
    },
    [types.set_signed_status](state, data){
        state.isSinged = data
    },
    [types.set_contract_data](state, data){
        state.contractData = data
    },
    [types.set_id_card_img](state, data){
        state.identification = data
    },
    [types.set_date_period](state, data){
        state.datePeriod = data
    },
    [types.set_selected_house](state, data){
        state.selectedHouseInfo = data
    },
    [types.set_available_house](state, data){
        state.availableHouseList = data
    },
    [types.set_renewal_contract](state, data){
        state.renewalContract = data
    },
    [types.set_default](state, data){
        state.contractStatus = 1
        state.isSinged = false
        state.contractData = Object.assign({}, defaultContractData)
        state.identification = Object.assign({}, defaultIdentification)
        state.datePeriod = Object.assign({}, defaultDatePeriod)
        state.selectedHouseInfo = Object.assign({}, defaultSelectedHouseInfo)
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/leaseMgt/renewalContract.js